import React, { forwardRef, useContext, useImperativeHandle, useRef } from 'react'
import Form from '../../Aplicacao/dispositivos/form'
import { LnsCadastroRapidoContext } from '../../../../contexts/LnsCadastroRapido'

const Dispositivos = forwardRef((props, ref) => {
    const formRef = useRef()
    const { applicationId, setDeviceId, deviceId, deviceProfileId } = useContext(LnsCadastroRapidoContext)

    useImperativeHandle(ref, () => ({
        onNext: async () => {
            const result = await formRef.current?.handleQuickRegister()

            if (!result?.success) {
                return false
            }

            setDeviceId(result.deviceId)
            return true
        }
    }))

    return (
        <div>
            <Form
                ref={formRef}
                isQuickRegister
                applicationId={applicationId}
                deviceId={deviceId}
                deviceProfileId={deviceProfileId}
            />
        </div>
    )
})

export default Dispositivos